<script>
    import { appManager } from "../AppManagerStore";
    import { _ } from "svelte-i18n";
</script>

<section class="py-8 py-md-11 bg-dark">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-8 text-center">
                <span class="badge rounded-pill bg-gray-700-soft mb-4">
                    <span id="get-started" class="h6 fw-bold text-uppercase">
                        {$_("communicate.cta.tagline")}</span>
                </span>

                <h1 class="display-4 text-white">
                    {$_("communicate.cta.title")}
                </h1>
                <p class="fs-lg text-muted mb-6 mb-md-8">
                    {$_("communicate.cta.description")}
                </p>

                <a
                    href="{$appManager.PublicUrl}contact"
                    target="_blank"
                    class="btn btn-success lift">
                    {$_("communicate.cta.contact")} <i class="fe fe-arrow-right" />
                </a>
            </div>
        </div>
    </div>
</section>
